import { BOOKING_REVAMP } from 'base/Url';
import axios, { apiWrapper } from '../../base/APIClient';

export const uploadInvoice = (formdata: any, config: any = {}) => {
  const { UPLOAD_INVOICE } = BOOKING_REVAMP;
  return apiWrapper(axios.post(UPLOAD_INVOICE, formdata, config));
};
